// @flow
import React, { Component } from 'react';
import { Button, Form, Modal, Dropdown, Accordion, Icon, Input } from 'semantic-ui-react';
import { getConnections, getStoredProcedures } from '../../modules/client';
import { map, first } from 'lodash';

export default class CreateGridModal extends Component<
    {
        clientId: Guid,
        onCancel: () => void,
        onSubmit: (data: any) => void,
        open: boolean
    },
    {
        connectionStringOptions: HTMLOptionsCollection,
        storedProcedureOptions: HTMLOptionsCollection,
        activeIndex: number,
        defaultConnectionStringValue: ?number,
        name: ?string,
        storedProcedureId: ?Guid,
        loading: boolean,
        nameMissing: boolean,
        storedProcedureIdMissing: boolean
    }
> {
    constructor() {
        super();
        this.state = {
            connectionStringOptions: new HTMLOptionsCollection(),
            storedProcedureOptions: new HTMLOptionsCollection(),
            activeIndex: 0,
            defaultConnectionStringValue: null,
            name: null,
            storedProcedureId: null,
            loading: false,
            nameMissing: false,
            storedProcedureIdMissing: false
        };
    }
    handleSubmit = () => {
        const { name, storedProcedureId } = this.state;
        if (!name || !storedProcedureId) {
            this.setState({
                nameMissing: name == null || name == '',
                storedProcedureIdMissing: storedProcedureId == null
            });
        } else {
            this.setState({ loading: true });
            this.props.onSubmit({ name, storedProcedureId, clientId: this.props.clientId });
        }
    };
    componentDidMount() {
        getConnections(this.props.clientId).then(connections => {
            const connectionOptions = map(connections, el => ({
                text: `${el.CompanyName}: ${el.ConnectionStringName}`,
                value: el.Id
            }));
            this.setState({ connectionStringOptions: connectionOptions });
            if (connections.length === 1) {
                var firstConnection = first(connectionOptions);
                getStoredProcedures(this.props.clientId, connections[0].Id).then(
                    storedProcedures => {
                        const storedProcOptions: HTMLOptionsCollection = map(
                            storedProcedures,
                            el => ({
                                text: el.name,
                                value: el.id
                            })
                        );
                        this.setState({
                            defaultConnectionStringValue: firstConnection.value,
                            activeIndex: 1,
                            storedProcedureOptions: storedProcOptions
                        });
                    }
                );
            }
        });
    }
    onChangeConnectionString = (event: any, data: any) => {
        getStoredProcedures(this.props.clientId, data.value).then(storedProcedures => {
            const storedProcOptions = map(storedProcedures, el => ({
                text: el.name,
                value: el.id
            }));
            this.setState({ storedProcedureOptions: storedProcOptions, activeIndex: 1 });
        });
    };
    handleChange = (e: any, data: any) => {
        this.setState({
            [data.name]: data.value,
            [`${data.name}Missing`]: data.value == null || data.value == ''
        });
    };

    handleClick = (e: any, titleProps: any) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex });
    };
    getConnectionStringChooser(
        options: HTMLOptionsCollection,
        onChange: Function,
        defaultValue: ?number
    ) {
        return (
            <Dropdown
                placeholder="Select Connection"
                fluid
                search
                selection
                options={options}
                onChange={onChange}
                defaultValue={defaultValue}
            />
        );
    }
    render() {
        const {
            activeIndex,
            connectionStringOptions,
            storedProcedureOptions,
            defaultConnectionStringValue,
            name,
            storedProcedureId,
            loading,
            nameMissing,
            storedProcedureIdMissing
        } = this.state;
        const validName = name != null && name != '';
        const validStoredProcedureId = storedProcedureId != null;
        return (
            <Modal open={this.props.open} size="small">
                <Modal.Header content="New Grid" />
                <Modal.Content>
                    <Form id="form-new-grid" onSubmit={this.handleSubmit}>
                        <Form.Input
                            label="Name"
                            placeholder="Grid Name"
                            name="name"
                            value={name}
                            onChange={this.handleChange}
                            error={nameMissing}
                        />
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 0}
                                index={0}
                                onClick={this.handleClick}
                            >
                                <Icon name="dropdown" />
                                Please choose a connection string?
                            </Accordion.Title>
                            <Accordion.Content
                                active={activeIndex === 0}
                                content={
                                    <Dropdown
                                        placeholder="Select Connection"
                                        fluid
                                        search
                                        selection
                                        options={connectionStringOptions}
                                        onChange={this.onChangeConnectionString}
                                        defaultValue={defaultConnectionStringValue}
                                    />
                                }
                            />

                            <Accordion.Title
                                active={activeIndex === 1}
                                index={1}
                                onClick={this.handleClick}
                            >
                                <Icon name="dropdown" />
                                Please choose a stored procedure?
                            </Accordion.Title>
                            <Accordion.Content
                                active={activeIndex === 1}
                                content={
                                    <Form.Dropdown
                                        placeholder="Select Stored Procedure"
                                        fluid
                                        search
                                        selection
                                        options={storedProcedureOptions}
                                        name="storedProcedureId"
                                        onChange={this.handleChange}
                                        error={storedProcedureIdMissing}
                                    />
                                }
                            />
                        </Accordion>
                        <Form.Input type="hidden" value={this.props.clientId} />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={this.props.onCancel} />
                    <Button
                        disabled={loading || !(validName && validStoredProcedureId)}
                        loading={loading}
                        content="Save"
                        form="form-new-grid"
                        primary
                        type="submit"
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./components/molecules/CreateGridModal.jsx